const filterHtmlTags = textWithHtmlTags =>
  textWithHtmlTags.replace(/[\s]+ |<[^>]+>/g, '').replace(/[\n]/g, ' ');

export default filterHtmlTags;
